function isYouTubeUrl(url) {
  if (!url) return false;
  return /youtube\.com|youtu\.be/i.test(String(url));
}

function getYouTubeEmbedUrl(url) {
  if (!url) return null;

  const raw = String(url).trim();
  let videoId = '';

  try {
    const parsed = new URL(raw, window.location.origin);
    const host = parsed.hostname.replace(/^www\./i, '').toLowerCase();

    if (host === 'youtu.be') {
      videoId = parsed.pathname.replace(/^\//, '').split('/')[0];
    } else if (host.includes('youtube.com') || host.includes('youtube-nocookie.com')) {
      if (parsed.pathname.startsWith('/watch')) {
        videoId = parsed.searchParams.get('v') || '';
      } else {
        const parts = parsed.pathname.split('/').filter(Boolean);
        const markerIndex = parts.findIndex(part =>
          ['embed', 'v', 'shorts', 'live'].includes(part)
        );
        if (markerIndex >= 0 && parts[markerIndex + 1]) {
          videoId = parts[markerIndex + 1];
        }
      }
    }
  } catch (error) {
    videoId = '';
  }

  if (!videoId) {
    const match = raw.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|v\/|shorts\/))([A-Za-z0-9_-]{6,})/i
    );
    if (match) {
      videoId = match[1];
    }
  }

  if (!videoId) {
    return null;
  }

  return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
}

let slideshowVideoModalDocumentBound = false;

function initSlideshowVideoModal() {
  const modal = document.getElementById('video-modal');
  const iframe = document.getElementById('video-iframe');

  if (!modal || !iframe) {
    return;
  }

  function closeModal() {
    modal.style.display = 'none';
    iframe.src = '';
    document.body.style.overflow = '';
  }

  function openModal(videoUrl) {
    const embedUrl = getYouTubeEmbedUrl(videoUrl);
    if (!embedUrl) {
      return false;
    }

    iframe.src = embedUrl;
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
    return true;
  }

  if (!slideshowVideoModalDocumentBound) {
    document.addEventListener(
      'click',
      function (event) {
        const link = event.target.closest('.custom-slideshow a[href]');
        if (!link) {
          return;
        }

        const videoUrl = link.getAttribute('data-video-url') || link.getAttribute('href');
        if (!isYouTubeUrl(videoUrl)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const activeModal = document.getElementById('video-modal');
        const activeIframe = document.getElementById('video-iframe');
        if (!activeModal || !activeIframe) {
          return;
        }

        const embedUrl = getYouTubeEmbedUrl(videoUrl);
        if (!embedUrl) {
          window.open(videoUrl, '_blank', 'noopener,noreferrer');
          return;
        }

        activeIframe.src = embedUrl;
        activeModal.style.display = 'block';
        document.body.style.overflow = 'hidden';
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      const activeModal = document.getElementById('video-modal');
      if (event.key === 'Escape' && activeModal && activeModal.style.display === 'block') {
        activeModal.style.display = 'none';
        const activeIframe = document.getElementById('video-iframe');
        if (activeIframe) {
          activeIframe.src = '';
        }
        document.body.style.overflow = '';
      }
    });

    slideshowVideoModalDocumentBound = true;
  }

  if (modal.dataset.videoModalBound === 'true') {
    return;
  }

  modal.dataset.videoModalBound = 'true';

  const closeBtn = modal.querySelector('.video-modal-close');
  const overlay = modal.querySelector('.video-modal-overlay');

  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  if (overlay) {
    overlay.addEventListener('click', closeModal);
  }
}

/**
 * Custom Slideshow + Geo Hero integration
 * ----------------------------------------
 * Related files (paste together with snippets/geo-hero-swap.liquid):
 *   sections/custom-slideshow.liquid
 *   templates/index.json (geo_city blocks + GPS bounds)
 *
 * Geo Hero Debug panel (from geo-hero-swap.liquid) dispatches:
 *   geo-hero:ready           — wait before init if data-geo-hero="true"
 *   geo-hero:reinit-carousel — rebuild carousel after Delhi/local banner swap
 *
 * If localhost and Shopify preview differ: clear sessionStorage geoHero.location.v4
 * or use debug panel "Fresh IP lookup" button.
 */
class BannerCarousel {
  constructor(element) {
    this.element = element;
    this.track = element.querySelector('.banner-carousel-track');
    this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
    this.slides = [];
    this.realSlideCount = 0;
    this.currentSlide = 0;
    this.isResetting = false;

    this.handleLoopReset = this.handleLoopReset.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.init();
  }

  getRealSlides() {
    const isMobile = this.mobileMediaQuery.matches;

    return Array.from(
      this.track.querySelectorAll('.banner-carousel-slide:not(.banner-carousel-slide--clone)')
    ).filter(slide => isMobile || !slide.classList.contains('banner-carousel-slide--mobile-only'));
  }

  rebuildSlides() {
    this.track.querySelectorAll('.banner-carousel-slide--clone').forEach(clone => clone.remove());

    const realSlides = this.getRealSlides();
    this.realSlideCount = realSlides.length;

    if (this.realSlideCount > 1) {
      const firstClone = realSlides[0].cloneNode(true);
      firstClone.classList.add('banner-carousel-slide--clone');
      firstClone.setAttribute('aria-hidden', 'true');
      this.track.appendChild(firstClone);
      this.slides = [...realSlides, firstClone];
      return;
    }

    this.slides = realSlides;
  }

  init() {
    if (!this.track) {
      return;
    }

    this.rebuildSlides();

    if (this.realSlideCount === 0) {
      return;
    }

    this.preloadImages();
    this.showSlide(0, false);
    this.element.classList.add('banner-carousel--initialized');
    window.addEventListener('resize', this.handleResize);
  }

  preloadImages() {
    const images = this.element.querySelectorAll('img');

    images.forEach(img => {
      if (img.complete) {
        img.style.opacity = '1';
      } else {
        img.addEventListener('load', () => {
          img.style.opacity = '1';
        });

        img.addEventListener('error', () => {
          img.style.opacity = '1';
        });
      }
    });
  }

  showSlide(index, animate = true) {
    if (!this.track || index < 0 || index >= this.slides.length) {
      return;
    }

    const slideWidth = this.element.getBoundingClientRect().width;

    if (animate) {
      this.track.style.transition = '';
    } else {
      this.track.style.transition = 'none';
    }

    this.track.style.transform = `translate3d(-${index * slideWidth}px, 0, 0)`;

    if (!animate) {
      void this.track.offsetHeight;
      this.track.style.transition = '';
    }

    const activeRealIndex = this.realSlideCount > 0 ? index % this.realSlideCount : index;
    const realSlides = this.getRealSlides();

    this.slides.forEach((slide, i) => {
      if (slide.classList.contains('banner-carousel-slide--clone')) {
        slide.classList.toggle('active', i === index);
        return;
      }

      const slideRealIndex = realSlides.indexOf(slide);
      slide.classList.toggle('active', slideRealIndex === activeRealIndex);
    });

    this.currentSlide = index;
  }

  clearLoopReset() {
    if (this.loopResetTimer) {
      clearTimeout(this.loopResetTimer);
      this.loopResetTimer = null;
    }
    this.track.removeEventListener('transitionend', this.handleLoopReset);
    this.isResetting = false;
  }

  handleLoopReset(event) {
    /* Ignore bubbled transitionend from child img opacity animations */
    if (event && (event.target !== this.track || event.propertyName !== 'transform')) {
      return;
    }

    this.clearLoopReset();
    this.showSlide(0, false);
  }

  handleResize() {
    const previousSlide = this.currentSlide;
    this.rebuildSlides();

    if (this.realSlideCount === 0) {
      return;
    }

    const nextSlide = Math.min(previousSlide, this.slides.length - 1);
    this.showSlide(nextSlide, false);
  }

  nextSlide() {
    if (this.slides.length <= 1 || this.isResetting) {
      return;
    }

    const nextIndex = this.currentSlide + 1;
    this.showSlide(nextIndex, true);

    if (nextIndex === this.realSlideCount) {
      this.isResetting = true;
      this.track.addEventListener('transitionend', this.handleLoopReset);
      /* Fallback if transform transitionend never fires (reduced motion, etc.) */
      this.loopResetTimer = setTimeout(() => {
        if (this.isResetting) {
          this.clearLoopReset();
          this.showSlide(0, false);
        }
      }, 700);
    }
  }
}

class CustomSlideshow {
  constructor(element) {
    this.element = element;
    element._customSlideshowInstance = this;
    this.carousels = [];
    this.autoplay = element.dataset.autoplay === 'true';
    this.autoplayInterval = parseInt(element.dataset.autoplayInterval, 10) * 1000 || 3000;
    this.autoplayTimer = null;
    this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');

    this.init();
  }

  getActiveCarousels() {
    if (this.mobileMediaQuery.matches) {
      return this.carousels.filter(carousel =>
        carousel.element.closest('.main_container') !== null
      );
    }

    return this.carousels;
  }

  hasAutoplaySlides() {
    return this.getActiveCarousels().some(carousel => carousel.realSlideCount > 1);
  }

  init() {
    const carouselElements = Array.from(this.element.querySelectorAll('.banner-carousel'));

    if (carouselElements.length === 0) {
      return;
    }

    carouselElements.forEach(carouselEl => {
      this.carousels.push(new BannerCarousel(carouselEl));
    });

    this.element.classList.add('slideshow--initialized');

    this.element.addEventListener('mouseenter', () => this.pauseAutoplay());
    this.element.addEventListener('mouseleave', () => {
      if (this.autoplay) {
        this.startAutoplay();
      }
    });

    if (this.autoplay && this.hasAutoplaySlides()) {
      this.startAutoplay();
    }
  }

  advanceAll() {
    this.getActiveCarousels().forEach(carousel => carousel.nextSlide());
  }

  startAutoplay() {
    if (!this.autoplay || !this.hasAutoplaySlides()) {
      return;
    }

    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
    }

    this.autoplayTimer = setInterval(() => {
      this.advanceAll();
    }, this.autoplayInterval);
  }

  pauseAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
}

let slideshowsInitialized = false;

function initAllSlideshows() {
  if (slideshowsInitialized) {
    return;
  }

  const slideshows = document.querySelectorAll('.custom-slideshow:not(.slideshow--initialized)');
  slideshows.forEach(slideshow => {
    new CustomSlideshow(slideshow);
  });

  slideshowsInitialized = true;
}

document.addEventListener('DOMContentLoaded', () => {
  initSlideshowVideoModal();
  initAllSlideshows();
});

document.addEventListener('geo-hero:ready', () => {
  /* Geo may finish before DOMContentLoaded — init if we missed DOMContentLoaded */
  if (!slideshowsInitialized) {
    initAllSlideshows();
  }
});

document.addEventListener('geo-hero:reinit-carousel', (event) => {
  /* Hero slide replaced by geo-hero-swap (e.g. Delhi banner) — rebuild carousel track */
  const element = event.detail && event.detail.element;
  if (!element) {
    return;
  }

  element.querySelectorAll('.banner-carousel-slide--clone').forEach(clone => clone.remove());
  element.classList.remove('banner-carousel--initialized');

  const slideshowEl = element.closest('.custom-slideshow');
  const slideshowInstance = slideshowEl && slideshowEl._customSlideshowInstance;

  /* Slideshow not ready yet — DOMContentLoaded init will pick up updated slides */
  if (!slideshowInstance) {
    return;
  }

  const newCarousel = new BannerCarousel(element);
  const carouselIndex = slideshowInstance.carousels.findIndex(
    carousel => carousel.element === element
  );

  if (carouselIndex >= 0) {
    slideshowInstance.carousels[carouselIndex] = newCarousel;
  }

  if (slideshowInstance.autoplay && newCarousel.realSlideCount > 1) {
    slideshowInstance.startAutoplay();
  }
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('#video-modal')) {
    initSlideshowVideoModal();
  }

  const slideshow = event.target.querySelector('.custom-slideshow');
  if (slideshow) {
    slideshowsInitialized = false;
    new CustomSlideshow(slideshow);
    slideshowsInitialized = true;
  }
});
